export default {
    diInformations: state => state.diInformations,
    diDocuments: state => state.diDocuments,
    diOrders: state => state.diOrders
};
